<div class="select-wrapper">
  <label class="label-outside">{{matlabelOpcional}}</label>
  <mat-form-field appearance="outline" class="w-100">
    <input matInput
           [formControl]="clientControl"
           [matAutocomplete]="auto"
           (focus)="abrirAutocomplete()"
           placeholder="{{placeholder}}"
           (click)="limparInput()"
           (blur)="restaurarClienteSeVazio()" />

    <mat-autocomplete #auto="matAutocomplete"(optionSelected)="onChange($event)">
      <mat-option *ngFor="let cliente of clientesFiltrados$ | async"
                  [value]="cliente">
        {{ cliente.nome }}
      </mat-option>

      <mat-option *ngIf="(clientesFiltrados$ | async)?.length === 0">
        Nenhum cliente encontrado
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>